module.exports = __webpack_public_path__ + "img/Arbiter-Dorel.2f120d7d.jpg";